import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby-plugin-react-intl';
import truncate from 'lodash/truncate';
import { useMediaQuery } from 'react-responsive';
import get from 'lodash/get';

import { useLocalFormat } from '@utils/localize';
import { breakpoints } from '@utils/responsive';
import Image from '@components/Image';
import * as styled from './styles';

function ImagePreview({
  suppressLabel,
  category,
  date,
  excerpt,
  title,
  heroImage,
  selectCategory,
  size,
  slug,
  type,
  itemType,
  theme,
}) {
  const localFormat = useLocalFormat();
  const isMobile = useMediaQuery({ maxWidth: breakpoints.mobile - 1 });

  let excerptLength = size === 'small' ? 64: 160;
  const bodyProps = {};
  const captionProps = {};
  const headingProps = {};

  if (type === 'card') {
    captionProps.sizes = ['small', 'regular'];
    captionProps.theme = theme;
    headingProps.level = 300;
    bodyProps.size = 'small';
  }

  if (type === 'column') {

    if (isMobile) {
      captionProps.size = 'small';
    }

    if (size === 'small' || isMobile) {
      bodyProps.size = 'small';
      captionProps.theme = theme;
      headingProps.level = 500;
    } else {
      headingProps.level = 400;
    }
  }

  return (
    <styled.Wrapper type={type}>
      {get(heroImage, 'asset.fluid') && (
        <styled.ImageWrapper type={type}>
          <Link to={slug} aria-label={title}>
            <Image fluid={heroImage.asset.fluid} />
          </Link>
        </styled.ImageWrapper>
      )}
      <styled.Content type={type}>
        <styled.Header size={size} type={type}>
          <styled.Caption {...captionProps}>
            {category && (
              <span onClick={() => selectCategory(category.slug.current)}>
                {category.title.en}
              </span>
            )}
            {date &&
              <styled.ItemDate>{localFormat(new Date(date), 'LLL d, yyyy')}</styled.ItemDate>}
            {itemType && !suppressLabel && (<styled.ItemType>{itemType}</styled.ItemType>)}
          </styled.Caption>
        </styled.Header>
        <Link to={slug} aria-label={title}>
          <styled.Heading {...headingProps}>{title}</styled.Heading>
          {type !== 'sidebar' && (
            <styled.Body {...bodyProps}>
              {truncate(excerpt, {
                length: excerptLength,
                separator: /,? +/,
              })}
            </styled.Body>
          )}
        </Link>
      </styled.Content>
    </styled.Wrapper>
  );
}

ImagePreview.propTypes = {
  excerpt: PropTypes.string,
  heading: PropTypes.string,
  heroImage: PropTypes.object,
  type: PropTypes.oneOf(['card', 'column', 'sidebar']),
  itemType: PropTypes.string,
  theme: PropTypes.oneOf(['blue', 'green', 'orange', 'purple', 'yellow']),
};

export default ImagePreview;
